export class AppUserTextRequest {
    public user: string;
    public screen_id : string;
    public screen_name: string;
    public text_num: number;
    public lang: string;

    constructor(user: string, lang: string, text_num: number, screen_id = '', screen_name = ''){
        this.user = user;
        this.screen_id  = screen_id;
        this.screen_name = screen_name;
        this.text_num = text_num;
        this.lang = lang;
    }
}